export const headCellsMap: { [key: number]: Array<{ id: string; numeric: boolean; disablePadding: boolean; label: string }> } = {
    1: [
      { id: "id", numeric: false, disablePadding: true, label: "S.no" },
      { id: "complaintName", numeric: false, disablePadding: true, label: "Complaint Name" },
      { id: "complaintDescription", numeric: true, disablePadding: false, label: "Complaint Description" },
      { id: "status", numeric: true, disablePadding: false, label: "Status" },
      { id: "action", numeric: true, disablePadding: false, label: "Action" },
    ],

    2: [
      { id: "id", numeric: false, disablePadding: true, label: "S.no" },
      { id: "name", numeric: false, disablePadding: true, label: "Name" },
      { id: "description", numeric: true, disablePadding: false, label: "Description" },
      { id: "status", numeric: true, disablePadding: false, label: "Status" },
      { id: "action", numeric: true, disablePadding: false, label: "Action" },
    ],

    3: [
      { id: "id", numeric: false, disablePadding: true, label: "S.no" },
      { id: "complaint", numeric: false, disablePadding: true, label: "Complaint" },
      { id: "advice", numeric: true, disablePadding: false, label: "Advice" },
      { id: "status", numeric: true, disablePadding: false, label: "Status" },
      { id: "action", numeric: true, disablePadding: false, label: "Action" },
    ],
    
    4: [
      { id: "id", numeric: false, disablePadding: true, label: "S.no" },
      { id: "diagnosis", numeric: false, disablePadding: true, label: "Diagnosis" },
      { id: "icdCode", numeric: true, disablePadding: false, label: "ICD Code" },
      { id: "status", numeric: true, disablePadding: false, label: "Status" },
      { id: "action", numeric: true, disablePadding: false, label: "Action" },
    ],
  };
  